// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@/assets/brand.css";

import { createVuetify } from "vuetify";

// LexFi light theme — "Institutional Intelligence" on white.
// Void-black/cyan brand recast for light surfaces: navy text, cyan accent.
export default createVuetify({
  theme: {
    defaultTheme: "lexfiLight",
    themes: {
      lexfiLight: {
        dark: false,
        colors: {
          background: "#FBFCFD", // page canvas (cool off-white)
          surface: "#FFFFFF",
          primary: "#2A6FD6", // Blue — links/accent/active
          secondary: "#0E9E76", // Teal — signal / CTA
          accent: "#2A6FD6",
          info: "#2A6FD6",
          success: "#0E9E76",
          error: "#C0392F",
          warning: "#A9762A",
        },
      },
    },
  },
  icons: {
    iconfont: "mdi",
    sets: {
      mt: {
        component: require("@/assets/icon-MT.svg"),
      },
      st: {
        component: require("@/assets/icono-ST.svg"),
      },
    },
  },
});
